import React from "react";
import styled from "styled-components";

import { useIntl } from "../../../../../shared/core/i18n/use-intl";
import type { Mandate } from "../../../../../shared/domains/mandates/mandate";
import { PrimaryButton } from "../../../common/buttons/primary-button";
import { Modal } from "../../../common/modal/modal";
import { RoundedModalContainer } from "../../../common/modal/rounded-modal-container";
import { fonts, theme } from "../../../styles/theme";

export interface ActivateMandateModalProps {
  mandate: Mandate;
  onConfirm: () => void;
  modalId: string;
  textPrompt: string;
}

export const MandateModal = (props: ActivateMandateModalProps) => {
  const { mandate, onConfirm, modalId, textPrompt } = props;

  const { formatMessage } = useIntl();

  const closeModal = () => {
    Modal.dismiss(modalId);
  };

  const handleConfirm = () => {
    onConfirm();
    closeModal();
  };

  return (
    <ModalContainer closeButton id={modalId}>
      <Container>
        <Title>
          <span>{formatMessage(textPrompt + ".title.first")}</span> {formatMessage(textPrompt + ".title.second")}
        </Title>
        <Message>
          {formatMessage(textPrompt + ".message", {
            reference: mandate.reference,
            creditorName: mandate.creditorName,
          })}
        </Message>
        <ConfirmButton size="M" onClick={handleConfirm}>
          {formatMessage("mandates.confirmButton")}
        </ConfirmButton>
      </Container>
    </ModalContainer>
  );
};

const ModalContainer = styled(RoundedModalContainer)``;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 56px;
`;

const Title = styled.span`
  ${fonts.bold}
  font-size: 1.5rem;
  color: #000000;
  span {
    color: ${theme.colors.success[500]};
  }
`;

const Message = styled.div`
  ${theme.text};
  color: black;
  font-size: 0.9375rem;
  line-height: 1.25rem;
  text-align: center;
  margin: 48px 10px 15px;
`;

const ConfirmButton = styled(PrimaryButton)`
  margin-top: 30px;
  margin-bottom: 30px;
`;
